var templateUrl = require('./toggle-switch.html');

angular.module('ciApp').component('toggleSwitch', {
  templateUrl: templateUrl,
  controllerAs: '$toggleSwitchCtrl',
  bindings: {
    rightChoiceOn: '=',
    leftChoiceText: '<',
    rightChoiceText: '<'
  },
  controller: function() {
    var ctrl = this;

    ctrl.$onInit = function() {};
  }
});



// WEBPACK FOOTER //
// ./common/components/toggle-switch/toggle-switch.component.js